import { initialCandidates } from "./collections/candidate-pool";
import { initialJobPosts } from "./collections/job-posts";
import { initialUsers } from "./collections/users";

import type { MockApplicantData } from "./candidate-pool.types";
import type { MockDbState } from "./mock-db-store";
import type { HiringTeamUser } from "../types";

type MockDBEntities = {
  users: MockDbState["users"];
  jobPosts: MockDbState["jobPosts"];
  candidates: MockDbState["candidates"];
  applicationNotes: MockDbState["applicationNotes"];
};

export function prepareDB(): MockDBEntities {
  const users = initialUsers;
  const candidates = resolveCandidateMappings();
  const jobPosts = resolveJobMappings(users);

  return {
    users,
    jobPosts,
    candidates,
    applicationNotes: [],
  };
}

function resolveJobMappings(users: MockDbState["users"]) {
  const resolveHiringTeamUser = (userId: string): HiringTeamUser => {
    const matchedUser = users.find((user) => user.id === userId);

    return {
      userId,
      displayName: matchedUser?.displayName ?? null,
    };
  };

  const jobPosts = initialJobPosts.map((jobPost) => {
    const managerId = JOB_POST_MANAGER_MAP[jobPost.jobPostId];
    const recruiterId = JOB_POST_RECRUITER_MAP[jobPost.jobPostId];
    const applicationIds = JOB_POST_CANDIDATES_MAP[jobPost.jobPostId] || [];

    return {
      ...jobPost,
      hiringManagers: managerId ? [resolveHiringTeamUser(managerId)] : [],
      recruiters: recruiterId ? [resolveHiringTeamUser(recruiterId)] : [],
      applicationIds,
    };
  });

  return jobPosts;
}

function resolveCandidateMappings(): MockApplicantData[] {
  const candidates = initialCandidates.map((candidate) => {
    const recruiterId = CANDIDATE_RECRUITER_MAP[candidate.applicationId];

    return {
      ...candidate,
      recruiterId,
    };
  });

  return candidates;
}

const JOB_POST_MANAGER_MAP: Record<string, string> = {
  j1: "u1",
  j2: "u2",
  j3: "u3",
  j4: "u4",
  j5: "u5",
  j6: "u6",
  j7: "u7",
  j8: "u8",
  j9: "u9",
  j10: "u10",
  j11: "u11",
  j12: "u12",
  j13: "u13",
  j14: "u14",
};

const JOB_POST_CANDIDATES_MAP: Record<string, string[]> = {
  j1: ["CAND-001", "CAND-002"],
  j2: ["CAND-003", "CAND-004", "CAND-005"],
  j3: ["CAND-006", "CAND-007", "CAND-008", "CAND-009"],
  j4: ["CAND-010", "CAND-011", "CAND-012"],
  j5: ["CAND-001", "CAND-003", "CAND-005"],
  j6: ["CAND-002", "CAND-004"],
  j7: ["CAND-006", "CAND-008", "CAND-010"],
  j8: ["CAND-007", "CAND-009", "CAND-011"],
  j9: ["CAND-012", "CAND-001", "CAND-002"],
  j10: ["CAND-003", "CAND-004", "CAND-005", "CAND-006"],
  j11: ["CAND-007", "CAND-008"],
  j12: ["CAND-009", "CAND-010", "CAND-011"],
  j13: ["CAND-012", "CAND-001", "CAND-003", "CAND-005"],
  j14: ["CAND-002", "CAND-004", "CAND-006"],
};

const JOB_POST_RECRUITER_MAP: Record<string, string> = {
  j1: "u16",
  j2: "u17",
  j3: "u18",
  j4: "u16",
  j5: "u17",
  j6: "u18",
  j7: "u16",
  j8: "u17",
  j9: "u18",
  j10: "u16",
  j11: "u17",
  j12: "u18",
  j13: "u16",
  j14: "u17",
};

const CANDIDATE_RECRUITER_MAP: Record<string, string> = {
  "CAND-001": "u16",
  "CAND-002": "u17",
  "CAND-003": "u18",
  "CAND-004": "u16",
  "CAND-005": "u17",
  "CAND-006": "u18",
  "CAND-007": "u16",
  "CAND-008": "u17",
  "CAND-009": "u18",
  "CAND-010": "u16",
};
